export const BASE_URL = '/';

export const CARD_SEARCH = 'card';
